var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nextLevel"},[_c('div',{ref:"inner",staticClass:"nextLevel__inner"},[_c('shell-image',{ref:"logo",staticClass:"nextLevel__image",attrs:{"sources":[
        {
          srcset: '/images/i-love-bio-logo.png',
          media: '(min-width: 200px)',
          type: 'image/png',
        } ]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }